module.exports = __webpack_public_path__ + "img/ico-memb-color.d6ece0bc.svg";